/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Company_TitleInputs */

const en_directory_footer_company_title = /** @type {(inputs: Directory_Footer_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const zh_directory_footer_company_title = /** @type {(inputs: Directory_Footer_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于我们`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Directory_Footer_Company_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_company_title = /** @type {((inputs?: Directory_Footer_Company_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Company_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_company_title(inputs)
	return zh_directory_footer_company_title(inputs)
});
export { directory_footer_company_title as "directory.footer.company_title" }